/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Beweegactiviteitenreeks_Api_Errors_Missing_Tenant_HeaderInputs */

const nl_beweegactiviteitenreeks_api_errors_missing_tenant_header = /** @type {(inputs: Beweegactiviteitenreeks_Api_Errors_Missing_Tenant_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De school identificatie ontbreekt`)
};

/**

* @param {Beweegactiviteitenreeks_Api_Errors_Missing_Tenant_HeaderInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const beweegactiviteitenreeks_api_errors_missing_tenant_header = /** @type {((inputs?: Beweegactiviteitenreeks_Api_Errors_Missing_Tenant_HeaderInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Beweegactiviteitenreeks_Api_Errors_Missing_Tenant_HeaderInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_beweegactiviteitenreeks_api_errors_missing_tenant_header(inputs)
});
export { beweegactiviteitenreeks_api_errors_missing_tenant_header as "beweegactiviteitenreeks.api_errors.missing_tenant_header" }